//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
let d=[[[1,"BoudaryCurveSelection",0,"ScCollector",0],[0,"ClearanceCoefficient",1,0],[0,"DiePenetration",1,0],[0,"DownToleranceForLength",1,0],[0,"DownToleranceForWidth",1,0],[0,"PunchPenetration",1,0],[0,"ThicknessDirectionOption",1,0],[0,"ThicknessValue",1,0],[0,"ToleranceCoefficient",1,0],[0,"UpToleranceForLength",1,0],[0,"UpToleranceForWidth",1,0]],[],[]];
SPLM.Tooling.DieDesPierceInsertBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.DieDesPierceInsertBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.DieDesPierceInsertBuilder.Direction = Object.freeze({
    "Upper" : "Upper", "Lower" : "Lower"});

SPLM.Tooling.DieDesPierceInsertBuilder.HoleShapeTypes = Object.freeze({
    "Circular" : "Circular", "Oblong" : "Oblong", "Square" : "Square", "Rectangular" : "Rectangular", "RoundedRectangular" : "RoundedRectangular", "ChordRectangular" : "ChordRectangular", "Hexagonal" : "Hexagonal", "Other" : "Other"});

export default SPLM;